import { FunctionComponent } from 'react';
import { DefaultChip } from 'shared/DefaultChip';

export const BetaTag: FunctionComponent = () => {
  return <DefaultChip label="Beta" color="warning" variant="outlined" />;
};
